export default __webpack_public_path__ + "../staticImages/liefererung-260.png";